import React, { useEffect, useContext, useState } from 'react';
import { ReactComponent as Bankdetails } from '../../../Assets/Images/bankDetails.svg';
import { useNavigate } from 'react-router-dom';
import AppTracking from '../../../Components/appTracking';
import { DataContext } from '../../../Components/DataContext.js';


const PaymentMethod = () => {
  const navigate = useNavigate();
  const { data } = useContext(DataContext);
  const newData = { ...data };
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentSwitch, setPaymentSwitch] = useState(false);



  useEffect(() => {
    if (newData.token == null) {
      navigate('/')
    }
    else {
      setPaymentTypes(newData.paymentModes[0]);
    }
  }, []);



  const handleChangePaymentSwitch = (event) => {
    setPaymentSwitch(event.target.checked);
    if (event.target.checked) {
      setPaymentTypes(newData.paymentModes[1]);
    }
    else {
      setPaymentTypes(newData.paymentModes[0]);
    }
  };

  const handleContinueClick = () => {

    if (paymentSwitch) {
      navigate('/bankDetails');
    }
    else {
      navigate('/upiDetails');
    }

  };


  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />

      <div className='content-wrapper responsive-wrapper'>
        <div className='row'>
          <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
            <div className='DarkPanel'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <Bankdetails />
              </div>
            </div>

            <section className='FormPanel py-5 mb-5 payment-method'>
              <h3>Payment Method</h3>
              <div className='card p-3 mb-3'>
                <div className='row'>
                  <div className='col-5'>
                    <img
                      src={paymentTypes.icon}
                      className=''
                      alt={paymentTypes.name}
                    />
                  </div>

                </div>
              </div>

              <div className='terms'>
                <input
                  className='form-check-input'
                  id='termsConditions'
                  name='termsConditions'
                  type='checkbox'
                  checked={paymentSwitch}
                  onChange={(e) => { handleChangePaymentSwitch(e) }}
                />
                <span className='UpiIdSpan'>
                  Don't have UPI ID? Switch to other payment method.
                </span>
              </div>

              <div className='row mt-5'>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <button type='submit' onClick={handleContinueClick} className='btn btn-primary'>
                    Continue
                  </button>
                </div>
              </div>
            </section>

          </div>
        </div>
      </div>

    </>
  );
};

export default PaymentMethod;
